let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3JEf6")).then(() => parcelRequire('090Qi'));